import ShippingOne from "../components/ShippingOne";
import BreadcrumbThree from "../components/BreadcrumbThree";
import DeleteUser from "../components/DeleteUser";
import { Helmet } from "react-helmet-async";

const DeleteUserPage = () => {
  return (
    <>

    
      <Helmet>
        <title> Delete User | VillageZone - Your Destination for Healthy, Preservative-Free, Handcrafted Goodness</title>
      </Helmet>

      {/* Breadcrumb */}
      <BreadcrumbThree title={"Delete My Account"} />

      {/* Account */}
      <DeleteUser />

      {/* ShippingOne */}
      <ShippingOne />

    </>
  )
}

export default DeleteUserPage